import { get } from '@/api';

export async function getCourses(client: number) {
  return (await get('api/widget/courses', { client })).body.data;
}

export async function getCampus(client: number, course: string) {
  return (await get('api/widget/courses/campus', { client, course })).body.data;
}

export async function getPeriods(client: number, course: string, campus: string) {
  return (await get('api/widget/courses/periods', { client, course, campus })).body.data;
}

export async function simulation(courseId: number) {
  return (await get(`api/widget/courses/simulation/${courseId}`)).body.data;
}

export async function getSimilar(data) {
  return (await get('api/widget/courses/similiar', data)).body.data;
}
